import { render } from "./ConfirmAccountView.vue?vue&type=template&id=7d2d0400"
import script from "./js/confirmAccountView.js?vue&type=script&lang=js&external"
export * from "./js/confirmAccountView.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__